import Vue from 'vue'

window.Cookie = require('js-cookie');
window.Velocity = require('velocity-animate');
window.Vue = Vue

require('waypoints/lib/noframework.waypoints.min.js');

/*=============================
=      Check Window Width     =
=============================*/

window.checkWidth = function checkWidth(width) {
    return window.innerWidth < width;
};

/*=============================
=          Initialize         =
=============================*/

window.body = document.body;
window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;
window.header = document.getElementById('header');
window.headerHeight = header.offsetHeight;
window.headerHeightSticky = checkWidth(1200) ? (headerHeight - topbarHeight) : (checkWidth(1920) ? Math.floor((window.innerWidth * (.039063 + .045313)) * 100) / 100 : 162);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if(token)
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
else
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');

/*=============================
=       Lazyload Scripts      =
=============================*/

window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
    var scriptWaypoint = new Waypoint({
        element: el,
        handler: function(direction) {
            addJS(src);

            this.destroy();
        },
        offset: offset
    });
};

window.addJS = function addJS(src) {
    var script = document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');

    document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
    Velocity(scrollTo, 'scroll', {duration: 800, offset: -(headerHeightSticky + 50)});
};

/*=============================
=       Get URL Parameter     =
=============================*/

window.getParameter = function getParameter(obj, parameter) {
    var value = '';

    obj.href.split('&').forEach(function(param) {
        if(param.indexOf(parameter) > -1)
            value = param.split(parameter+'=')[1].split('#')[0];
    });

    return value;
};

/*=============================
=      Google Tag Manager     =
=============================*/

window.addEventListener('load', function() {
    var gtm = process.env.GTM_ID;

    if(gtm) {
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', gtm);

        var noscript = document.createElement('noscript');

        noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id='+gtm+'" height="0" width="0" style="display:none;visibility:hidden"></iframe>';

        document.body.appendChild(noscript);
    }
});